module.exports = __webpack_public_path__ + "static/media/radio_traditional_selected.688b85db.svg";